import React from 'react'
// todo - fix импорт из фичи
import { ThreeDs2PcekAuth, ThreeDsAuth } from '@features/auth/three-ds/@x/payment-form'
import { ConfirmationType } from '@entities/payment'
import { Notice } from '@shared/ui/molecules/Notice'
import { NoticeType } from '@shared/config/notice'
import { TransactionResponse } from '@root/api/ump-ewallet'

interface PaymentConfirmationProps {
  paymentData: TransactionResponse
  getResultPath: (mdOrder: string) => string
  handleCallOtp?: () => void
  handleCall3DS?: () => void
  handleCall3DS2?: (data: TransactionResponse) => void
  handleError?: (error?: string) => void
}

export const getConfirmationContent = ({
  paymentData,
  getResultPath,
  handleCallOtp,
  handleCall3DS,
  handleCall3DS2,
  handleError,
}: PaymentConfirmationProps) => {
  switch (paymentData.confirmationType) {
    case ConfirmationType.OTP_PAYMENT_PAGE:
    case ConfirmationType.OTP_SMS_CALLBACK:
      handleCallOtp?.()
      break

    case ConfirmationType.FINISH_3DS:
      if (paymentData?.mdOrder && paymentData?.acsUrl && paymentData?.PaReq) {
        handleCall3DS?.()

        ThreeDsAuth.call({
          mdOrder: paymentData.mdOrder,
          url: paymentData.acsUrl,
          paReq: paymentData.PaReq,
          callbackUrl: getResultPath(paymentData?.mdOrder),
        })
      }
      break

    case ConfirmationType.FINISH_3DS2:
      if (paymentData?.mdOrder) {
        ThreeDs2PcekAuth.call({
          mdOrder: paymentData.mdOrder,
          url: paymentData?.acsUrl as string,
          callbackUrl: getResultPath(paymentData?.mdOrder),
          threeDsMethodData: paymentData?.threeDsMethodData,
          threeDsMethodUrl: paymentData?.threeDsMethodUrl,
        })
          .then((data) => {
            // frictionless flow
            if (!data.errorCode) {
              handleCall3DS2?.(data)
            } else {
              handleError?.(data?.errorMessage)
            }
          })
          .catch(() => {
            handleError?.()
          })
      }
      break

    default:
      return <Notice type={NoticeType.WARNING} message="Повторите попытку" />
  }
}
